'use client';

import { useRef } from 'react';
import { useWheelToHorizontalScroll } from '@/hooks';
import {
  HorizontalResourceCard,
  PostData,
} from '@/slices/ResourceLibraryGrid/variants/components';

/**
 * Horizontal, wheel-scrollable rail of related-post cards. Reuses the
 * ResourceLibraryGrid `HorizontalResourceCard` for visual consistency and the
 * shared `useWheelToHorizontalScroll` hook so a vertical wheel scrolls the rail.
 */
export function RelatedCardsRail({ posts }: { posts: PostData[] }) {
  const railRef = useRef<HTMLDivElement>(null);
  useWheelToHorizontalScroll(railRef);

  return (
    <div ref={railRef} className="flex gap-[30px] overflow-x-auto no-scrollbar">
      {posts.map((post) => (
        <div
          key={post.id}
          className="w-[300px] shrink-0 sm:w-[440px] lg:w-[511px]"
        >
          <HorizontalResourceCard post={post} />
        </div>
      ))}
    </div>
  );
}
